<template>
  <v-container>
    <h2>Diretoria</h2>
    <div class="direction-list">
      <template v-if="!direction.length">
        <v-skeleton-loader class="mb-4" type="card"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4" type="card"></v-skeleton-loader>
        <v-skeleton-loader class="mb-4" type="card"></v-skeleton-loader>
      </template>
      <template v-else>
        <direction-card v-for="(article, i) in direction" :key="i" :img="files + article.img" :title="article.title" :ocupation="article.ocupation"></direction-card>
      </template>
    </div>
  </v-container>
</template>

<script>
import DirectionCard from '../components/DirectionCard'

export default {
  computed: {
    files() {
      return this.$store.state.files + '/'
    },
    direction() {
      return this.$store.state.direction
    }
  },
  beforeCreate() {
    this.$store.dispatch('getAllDirection')
  },


  components: {
    DirectionCard
  }
}
</script>

<style>
.direction-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, 336px);
  grid-gap: 20px;
  justify-content: center;
}
</style>